/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetExperimentCredibleIntervalTimeseriesResultsPathParams = NonNullable<
  operations['getExperimentCredibleIntervalTimeseriesResults']['parameters']['path']
>;

export type GetExperimentCredibleIntervalTimeseriesResultsQueryParams = NonNullable<
  operations['getExperimentCredibleIntervalTimeseriesResults']['parameters']['query']
>;

export interface Input extends GetExperimentCredibleIntervalTimeseriesResultsPathParams {
  apiVersion?: string;
  query?: GetExperimentCredibleIntervalTimeseriesResultsQueryParams;
}

export async function getExperimentCredibleIntervalTimeseriesResults(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}/metrics/{metricKey}/results/timeseries',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
